import { render, staticRenderFns } from "./print-status-select.vue?vue&type=template&id=167d6a7e&"
import script from "./print-status-select.vue?vue&type=script&lang=js&"
export * from "./print-status-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports